<div class="card-inline">
    <button matTooltip="Adjuntar PDF" class="card-inline" (click)="fileInput.click()" mat-mini-fab>
    <mat-icon>cloud_upload</mat-icon>
    <input
      [style.display]="hideElement ? 'none' : 'inherit'"
      type="file"
      #fileInput
      (change)="uploadFile($event.target.files)"
    />
  </button>
</div>
<div class="card-inline">
    <h3>Adjuntar pdf</h3>
</div>
<mat-divider></mat-divider>
<br>
<br>
<div class="center" *ngIf="loading">
    <mat-spinner diameter="20"></mat-spinner>
</div>
<table>
    <tr *ngFor="let file of files">
        <td style="min-width: 200px;" (click)="download(file)">
            {{ file.Name }}
        </td>
        <td>
            <mat-icon (click)="delete(file)">delete</mat-icon>
        </td>
    </tr>
</table>